module.exports = __webpack_public_path__ + "static/project-12e-eda1383e8a826e033d39bec6efc26d0d.png";